import { getProductTypeName } from "../Order/Order";

const headers = [
	{ header: 'Id', key: 'id' },
	{ header: 'Req. at', key: 'requestedAt' },
	{ header: 'Req. by', key: 'requestedBy' },
	{ header: 'Resp. at', key: 'respondedAt' },
	{ header: 'Resp. by', key: 'respondedBy' },
	{ header: 'Trading desk', key: 'tradingDeskName' },
	{ header: 'Product', key: 'product' },
	{ header: 'Side', key: 'side' },
	{ header: 'Ticker', key: 'symbol' },
	{ header: 'Quantity', key: 'quantity' },
	{ header: 'Price', key: 'price' },
	{ header: 'Status', key: 'status' },
	{ header: 'Used', key: 'wasUsed' },
	{ header: 'Reason', key: 'rejectReason' }
]

const buildRows = (quotes) => {
	return quotes.map(quote => {
		return {
			id: quote.id,
			requestedAt: quote.AdvisorQuoteRequestedDate,
			requestedBy: quote.AdvisorQuoteRequestedBy,
			respondedAt: quote.AdvisorQuoteRespondedDate,
			respondedBy: quote.AdvisorQuoteRespondedBy,
			product: getProductTypeName(quote.product),
			side: quote.AdvisorQuoteIsBuy ? 'Buy' : 'Sell',
			symbol: quote.AssetTicker,
			tradingDeskName: quote.tradingDeskName,
			quantity: quote.AdvisorQuoteQuantity,
			price: quote.AdvisorQuotePrice,
			status: quote.AdvisorQuoteStatus,
			wasUsed: quote.wasUsed ? 'Yes' : 'No',
			rejectReason: quote.AdvisorQuoteRejectReason
		}
	})
}


export const getReportQuotesData = (quotes) => {
	return {
		headers,
		rows: buildRows(quotes)
	}
}